<template>
  <div>
    <div :class="`card br-10 ${match.can_predict?'relative z-20':'mb-6'}`">
      <div class="w-full bg-white  px-2 br-t-10">
        <span v-if="!match.can_predict" class="text-xxs text-white bg-green uppercase font-semibold rounded-sm px-1">{{match.get_status ? match.get_status: 'Live'}}</span>
        <span v-if="match.can_predict && match.match_remaining_time" class="text-xxs font-normal rounded-sm px-1 text-opacity-50 text-black">Starts in</span><span v-if="match.can_predict && match.match_remaining_time" class="text-xxs font-medium text-black">{{match.match_remaining_time}}</span>
      </div>
      <div class="w-full flex p-4 justify-between items-center">
        <div class="w-1/3 flex flex-col items-center self-start">
          <div class="rounded-full w-18 h-18 mb-2">
            <img  class="rounded-full w-18 h-18" :src="match.home_team_logo?match.home_team_logo:`@/assets/ipl-team.jpg`" @error="loadDefaultUrl" alt="">
          </div>
          <span class="text-xs font-medium text-black uppercase text-center">{{match.home_team}}</span>
        </div>
        <div class="w-1/3 flex items-center justify-center">
          <img src="@/assets/arrow-l.svg" alt="">
          <span class="text-xxs font-medium text-black px-1">vs</span>
          <img src="@/assets/arrow-r.svg" alt="">
        </div>
        <div class="w-1/3 flex flex-col items-center justify-center self-start">
          <div class="rounded-full w-18 h-18 mb-2">
            <img  class="rounded-full w-18 h-18" :src="match.opponent_team_logo?match.opponent_team_logo:`@/assets/ipl-team.jpg`" @error="loadDefaultUrl" alt="">
          </div>
          <span class="text-xs font-medium text-black uppercase text-center">{{match.opponent_team}}</span>
        </div>
      </div>
    </div>
    <router-link v-if="match.can_predict" :to="`/play/${match.id}`" class="btn-login font-bold text-white w-full -mt-4 p-4  relative z-10 pt-7 block text-center mb-6" >Predict and Win</router-link>
  </div>
</template>
<script type="text/javascript">
  export default {
    props: {
      match: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    methods:{
      loadDefaultUrl(event){
        event.target.src = require(`@/assets/ipl-team.jpg`);
      }
    }
  }
</script>
<style type="text/css" scoped>
  .card {
    background: linear-gradient(180deg, #F5F5F5 0%, #F0F0F0 100%);
  }
  .btn-login {
    background: linear-gradient(180deg, #FF9C59 0%, #ED6C15 100%);
    box-shadow: inset 0px -4px 0px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
  }

  .btn-login:active{
    background: linear-gradient(180deg, #FF9C5999 0%, #ED6C1599 100%);
    outline: none;
  }
  .br-t-10 {
    border-radius: 10px 10px 0 0;
  }

</style>